<template>
  <div class="n-header">
    <!-- 定宽布局 -->
    <div class="container">
      <!-- logo -->
      <div class="n-logo">
        <!-- <img src="" alt="" /> -->
        <h4>晋江奇境</h4>
      </div>

      <!-- 导航列表 -->
      <div class="n-list">
        <a href="/" class="active">网站首页</a>
        <a href="/#/ac1">动漫产品</a>
        <a href="/infoList.html">付费资讯</a>
        <a href="/#/xy2">联系我们</a>
        <a href="/#/xy4">自审制度</a>
        <a href="/#/pay">会员专区</a>
        <a v-if="LoggedShow" @click="goLogin">登录</a>
        <a v-if="LoggedShow" @click="goRegister">注册</a>
        <a v-if="!LoggedShow" v-text="this.nv_user.Username"></a>
        <a v-if="!LoggedShow" @click="tolg">退出登录</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 按钮显示/隐藏
      LoggedShow: true,
      // 获取到 user 用户信息
      nv_user: JSON.parse(window.localStorage.getItem("user")),
      // 存储状态
      state: JSON.parse(window.localStorage.getItem("state")),
    };
  },
  mounted() {
    this.logged();
  },
  methods: {
    // 登录时隐藏逻辑
    logged() {
      if (this.state == "0") {
        this.LoggedShow = false;
      }
    },
    // 登录跳转
    goLogin() {
      this.$router.push("/login");
    },
    // 注册跳转
    goRegister() {
      this.$router.push("/register");
    },
    // 退出登录
    tolg() {
      window.localStorage.setItem("state", "10");
      this.LoggedShow = true;
      location.reload();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";

.n-header {
  .container {
    line-height: 65px;
    display: flex;
    align-items: center;

    // logo
    .n-logo {
      width: 400px;
      height: 65px;
      width: 100%;
        display: flex;
        align-items: center;
        
      h4 {
        font-size: 14px;
        font-weight: bold;
      }
      
    }

    .n-list {
      flex: 1;
      margin-left: 9%;
      display: flex;
      align-items: center;
      a {
        text-decoration: none;
        width: 85px;
        height: 42px;
        display: block;
        text-align: center;
        line-height: 42px;
        font-size: 12px;
        font-weight: bold;
        margin: 0 10px;
        color: #333;
        cursor: pointer;
        &.active {
          background: #4bc0bf;
          color: #fff;
        }
        &:hover {
          background: #4bc0bf;
          color: #fff;
        }
      }
    }
  }
}
</style>
